/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'
import ReactMarkdown from 'react-markdown'
import styled from '@emotion/styled'
import { HelpMarkdowns } from 'src/help'
import { Colors, useTypography, Typographies, Shapes } from 'src/components/theme'

type HelpMarkdownProps = {
  file: string
}

const HelpMarkdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[1]}px;
  padding: 0 ${Shapes.spacing[2]}px;
  ${useTypography(Typographies.text1m)}
  color: ${Colors.textWhite};

  & > p {
    margin: ${Shapes.spacing[1]}px 0;
  }

  & h1 {
    ${useTypography(Typographies.title2)}
    margin: ${Shapes.spacing[2]}px 0;
  }
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    ${useTypography(Typographies.text1)}
    margin: ${Shapes.spacing[2]}px 0;
  }

  & ol {
    padding-left: ${Shapes.spacing[3]}px;
  }

  & ul {
    padding-left: 0;
    list-style-type: none;
  }

  & ul li:before {
    content: '○';
    font-weight: bold;
    color: ${Colors.blueDark};
    margin-right: ${Shapes.spacing[2]}px;
  }

  & hr {
    border-color: ${Colors.textLight};
  }
`

export const HelpMarkdown: React.FC<HelpMarkdownProps> = (props) => {
  const { file } = props

  const md = HelpMarkdowns[file] || 'Help not available'

  return (
    <HelpMarkdownWrapper>
      <ReactMarkdown>{md}</ReactMarkdown>
    </HelpMarkdownWrapper>
  )
}
